<template>
  <div id="app" class="menu">
    <mt-header fixed title="筑富协同办公平台"> </mt-header>
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <div
      id="content"
      class="content"
      style="background: none"
      v-else
      :style="{
        height: 'calc(100vh - 50px)',
        background: '#f6f6f6'
      }"
    >
      <div>
        <div class="menu-head">
          <img class="img-full" src="~@/assets/images/menu/index.png" />
        </div>
      </div>
      <div class="main_content" style="display: flex; flex-direction: column">
        <!-- 公文 -->
        <div class="subscribe" >
          <div class="titleBox">
            <img
                class="icon"
                :src="require(`@/assets/login-index/indexICON16.png`)"
            />
            <div class="title_home">公文</div>
          </div>
          <div v-if="roleId==12">
            <div class="sixthContent" style="justify-content: space-around">
              <div style="display: flex; align-items: flex-end"
                   @click="linkUrl('/document/deptDocumentList')">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON9.png`)"
                />
                <div class="right">
                  <div class="text">公文查阅</div>
                </div>
              </div>
              <div class="line"></div>
              <div style="display: flex; align-items: flex-end"  v-if="roleId==12"
                   @click="linkUrl('/document/proposedDocumentList')">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON10.png`)"
                />
                <div class="right">
                  <div class="text">公文拟办</div>
                  <div v-if="docNum > 0" class="badge">{{ docNum }}</div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="sixthContent" style="justify-content: space-around" v-if="roleId==10||roleId==1">
              <div
                  style="display: flex; align-items: flex-end;"
                  @click="linkUrl('/document/addDocument')"
              >
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON17.png`)"
                />
                <div class="right">
                  <div class="text">新建公文</div>
                </div>
              </div>
              <div class="line"></div>
              <div style="display: flex; align-items: flex-end"
                   @click="linkUrl('/document/documentList')">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON74.png`)"
                />
                <div class="right">
                  <div class="text">公文台账</div>
                </div>
              </div>
            </div>
            <div class="sixthContent" style="justify-content: space-around">
              <div style="display: flex; align-items: flex-end"
                   @click="linkUrl('/document/deptDocumentList')"
                   v-if="roleId==2 || roleId==3 ||roleId==4 || roleId==5 ||roleId==10||roleId==6||roleId==1">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON9.png`)"
                />
                <div class="right">
                  <div class="text">公文查阅</div>
                </div>
              </div>
              <div class="line" v-if="roleId==2 || roleId==3 ||roleId==4||userId==7"></div>
              <div style="display: flex; align-items: flex-end"
                   @click="linkUrl('/document/shenDocument')"
                   v-if="roleId==2 || roleId==3 ||roleId==4">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON8.png`)"
                />
                <div class="right">
                  <div class="text">公文批示</div>
                  <div v-if="docPsNum > 0" class="badge">{{ docPsNum }}</div>
                </div>
              </div>
              <div style="display: flex; align-items: flex-end" v-else-if="userId==7"
                   @click="linkUrl('/document/archiveDocumentList')">
                <img
                    class="icon"
                    :src="require(`@/assets/login-index/indexICON6.png`)"
                />
                <div class="right">
                  <div class="text">公文归档</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 流程 -->
        <div
            class="subscribe"
        >
          <div class="titleBox">
            <img
                class="icon"
                :src="require(`@/assets/login-index/indexICON5.png`)"
            />
            <div class="title_home">流程</div>
          </div>
          <div class="sixthContent" style="justify-content: space-around"
               v-if="roleId==4||roleId==5||roleId==6||roleId==10||roleId==12||roleId==1">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/addProcedure')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON17.png`)"
              />
              <div class="right">
                <div class="text">新建流程</div>
              </div>
            </div>
            <div class="line"></div>
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/procedureList')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">流程台账</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around"
          v-if="roleId==2||roleId==3||roleId==4||roleId==10||roleId==12||roleId==1">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/shenList')"
                v-if="roleId==4||roleId==10||roleId==12||roleId==1"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON10.png`)"
              />
              <div class="right">
                <div class="text">流程审批
                <div v-if="proNum > 0" class="badge">{{ proNum }}</div>
                </div>
              </div>
            </div>
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/procedure/leaderShenList')"
                v-if="roleId==2||roleId==3"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON10.png`)"
              />
              <div class="right">
                <div class="text">流程审批
                  <div v-if="proNum > 0" class="badge">{{ proNum }}</div>
                </div>
              </div>
            </div>
            <div class="line" v-if="roleId==10||roleId==1"></div>
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/procedure/archiveList')"
                 v-if="roleId==10||roleId==1">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">流程归档</div>
              </div>
            </div>
          </div>
        </div>
        <!-- 会议-->
        <div
            class="subscribe"
        >
          <div class="titleBox">
            <img
                class="icon"
                :src="require(`@/assets/login-index/indexICON5.png`)"
            />
            <div class="title_home">会议</div>
          </div>
          <div class="sixthContent" style="justify-content: space-around">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/meeting/addMeeting')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON17.png`)"
              />
              <div class="right">
                <div class="text">新建会议</div>
              </div>
            </div>
            <div class="line"></div>
            <div style="display: flex; align-items: flex-end"
                 @click="linkUrl('/meeting/meetingList')">
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON74.png`)"
              />
              <div class="right">
                <div class="text">会议台账</div>
              </div>
            </div>
          </div>
          <div class="sixthContent" style="justify-content: space-around">
            <div
                style="display: flex; align-items: flex-end"
                @click="linkUrl('/meeting/meetingNoticeList')"
            >
              <img
                  class="icon"
                  :src="require(`@/assets/login-index/indexICON10.png`)"
              />
              <div class="right">
                <div class="text">会议通知</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-tab-module selected="首页" :messageNum="messageNum"></v-tab-module>

  </div>
</template>
<script>
import tabModule from "@/components/footerBar/index.vue";
import request from "@/utils/keyCloakRequest";
import {getLocalData} from "@/utils/sessionData";
export default {
  components: {
    "v-tab-module": tabModule
  },
  beforeMount() {},
  data() {
    return {
      docPsNum: 0,  // 公文批示待办数
      docNum: 0,    // 公文拟办待办数
      proNum: 0,// 流程审核待办数
      isLoading: false,
      messageNum: 0,
      analysisData: {},
      userId: null,
      userInfo: {},
      roleId: null,
      timer: null   // 定时器对象
    };
  },
  // 版本更新
  created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.roleId = this.userInfo.role.roleId
    this.userId = this.userInfo.userId
    this.getHomeCount();
  },
  mounted() {
    this.startPolling();
  },
  beforeDestroy() {
    this.stopPolling();
  },
  computed: {
  },
  methods: {
    // 启动轮询
    startPolling() {
      this.timer = setInterval(() => {
        this.getHomeCount();
      }, 30000); // 30秒轮询一次
      this.getHomeCount(); // 立即执行一次
    },
    // 停止轮询
    stopPolling() {
      clearInterval(this.timer);
    },
    getHomeCount(){
      request({
        url: "getAppHomeNum?userId="+this.userId,
        method: "get"
      }).then(  response => {
        this.docPsNum=response.docPsNum,  // 公文批示待办数
        this.docNum=response.docNum,    // 公文拟办待办数
        this.proNum=response.proNum// 流程审核待办数
      })
    },
    linkUrl(url, params) {
      this.$router.push({
        path: url,
        query: params
      });
    }
  },
};
</script>
<style lang="less" scoped>
.right {
  position: relative;
  margin-left: 8px;
}
.badge {
  /* 原有样式保留 */
  position: absolute;
  top: -8px;
  right: -50px;
  min-width: 50px;
  height: 50px;
  line-height: 50px;
  border-radius: 8px;
  background-color: #f56c6c;
  color: white;
  text-align: center;
  padding: 0 4px;

  /* 新增字体放大样式 */
  font-size: 30px;  /* 原12px调整为14px */
  font-weight: bold;  /* 加粗显示 */
}
</style>
